<template>
  <div data-scroll-container>
    <slot />
  </div>
</template>

<script>
import LocomotiveScroll from "locomotive-scroll";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
export default {
  name: "SmoothScroll",

  data() {
    let that = this;
    return {
      Loco: null,
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,
      hasRotated: false,
    };
  },
  computed: {
    locale(){
      return this.$store.state.main.locale;
    },
    stopScrolling() {
      return this.$store.state.main.galleryTouch;
    },
    ageVerified() {
      return this.$store.state.main.ageVerified;
    },
    updateOnLoad() {
      return this.$store.state.main.current_content_request_status;
    }
  },

  mounted() {
    let Alltrigger = ScrollTrigger.getAll();
    for (let i = 0; i < Alltrigger.length; i++) {
      Alltrigger[i].kill(true);
    }
    
    setTimeout(() => {
      this.initGsap();
    }, 700);
  },

  methods: {
    onResize() {
      this.windowHeight = window.innerHeight;
      this.windowWidth = window.innerWidth;
      this.Loco.update();
    },
    initGsap() {
      let __that = this;
      gsap.registerPlugin(ScrollTrigger);

      const locoScroll = new LocomotiveScroll({
        el: document.querySelector("[data-scroll-container]"),

        direction: "vertical",

        multiplier: navigator.userAgent.toLowerCase().indexOf('firefox') > -1  ? 1  : 0.8,
        smooth: true,
        touchMultiplier: 10,
        firefoxMultiplier: 300,
        gestureDirection: "vertical",
        tablet: {
          smooth: true,
          // direction: "vertical",

          breakpoint: 1024
        },
        smartphone: {
          smooth: false,
          // direction: "vertical"
          breakpoint: 767
        }
      });

      this.Loco = locoScroll;

      this.Loco.stop();
      setTimeout(() => {
        this.Loco.start();
      }, 2000);

      this.Loco.on("scroll", ScrollTrigger.update);

      ScrollTrigger.scrollerProxy("[data-scroll-container]", {
        scrollTop(value) {
          return arguments.length
            ? locoScroll.scrollTo(value, 0, 0)
            : locoScroll.scroll.instance.scroll.y;
        },
        getBoundingClientRect() {
          return {
            top: 0,
            left: 0,
            width: window.innerWidth,
            height: window.innerHeight
          };
        },

        pinType: document.querySelector("[data-scroll-container]").style
          .transform
          ? "transform"
          : "fixed"
      });

      let tl;
      let pyramids = document.querySelector(".pyramid-wrapper");
      let bottles = document.querySelector(".bottles-div");
      let cock = document.querySelector(".cocktail-box");
      let _that = this;
      function preventRotate() {
       
        let imagePath = __that.locale == 'ge' ? "/img/shake" : "/img/shake_eng";
        

        let frameNumber = 6;

        if (
          document
            .querySelector(".bottleitself")
            .classList.contains("has-rotated")
            && __that.hasRotated
        ) {
          setInterval(() => {
            if (frameNumber != 0) {
              frameNumber--;

              document
                .querySelector(".bottleitself")
                .setAttribute("src", imagePath + `/${frameNumber}.png`);
            }
          }, 50);
          document
            .querySelector(".bottleitself")
            .classList.remove("has-rotated");
        }
        __that.hasRotated = false;
        
      }
      function adjustToSize(y1, x1) {
        tl = gsap
          .timeline({ defaults: { ease: "easeIn" } })

          .to(".bottle-1", {
            y: y1,
            x: x1,
            duration: 1,
            scale: 1,
            rotate: -14.5,

            onStart: function() {},
            onReverseComplete: function() {
              // preventRotate();
            }
          })

     

        ScrollTrigger.create({
          trigger: ".cont-2",
          scroller: "[data-scroll-container]",
          start: "100px bottom",

          end: "+=1210",

          scrub: 0.3,
          onScrubComplete: self => tl.pause,
          animation: tl
        });

        ScrollTrigger.create({
          trigger: ".cont-2",
          scroller: "[data-scroll-container]",
          start: "800px bottom",

          end: "+=1100",

          onEnter: function() {
            if(!__that.hasRotated){

            
            document
              .querySelector(".bottleitself")
              .classList.add("has-rotated");
            let totalFrames = 6;
              let imagePath = __that.locale == 'ge' ? "/img/shake" : "/img/shake_eng";
            let frameNumber = 0;
            setInterval(() => {
              if (frameNumber < totalFrames && frameNumber != totalFrames) {
                frameNumber++;

                document
                  .querySelector(".bottleitself")
                  .setAttribute("src", imagePath + `/${frameNumber}.png`);
              }
            }, 50);
            __that.hasRotated = true;
          
          }
          }
        });

             ScrollTrigger.create({
          trigger: ".cont-2",
          scroller: "[data-scroll-container]",
           start:  "+=350 bottom",

          end:   "bottom bottom",
       
        // markers: true,
        onEnter: function(){
          // console.log('enter')
        },
            onLeaveBack: function() {
              preventRotate();
              // console.log('dsajhkdhjkasjhkdas');
          },

        });
      }
      let that2 = this;
      function adjustToSize2(y1, x1) {
        tl = gsap
          .timeline({ defaults: { ease: "easeIn" } })

          .to(".bottle-1", {
            y: y1,

            x: x1,

            duration: 1,
            scale: 1,
            rotate: -14.5,

            onStart: function() {
              // console.log('start')
            },
            onReverseComplete: function() {
              // preventRotate();
              // console.log('reverse complete')
            },
            // onEnter: function(){
            //   preventRotate();
            //   console.log('on enter back')


            // }
          })

        ScrollTrigger.create({
          trigger: ".cont-2",
          scroller: "[data-scroll-container]",
          // start: `${((that2.windowHeight - 690) * 56.04483586869495) /
          //   100} bottom`,
               start: window.innerWidth >= 1024 && window.innerWidth <= 1199 ?   "0px bottom"    
               :   window.innerHeight <= 900 && window.innerHeight >= 800 && window.innerWidth <= 1650 && window.innerWidth >= 1440 ?  "0px bottom" 
              //  :  `${((that2.windowHeight - 690) * 56.04483586869495) / 100} bottom`,
               :  '0px bottom',
          end: 
          window.innerWidth >= 1024 && window.innerWidth <= 1199 ?  "+=800" 
          : window.innerWidth <= 1626 && window.innerWidth  >= 1440 ?  "+=950"
          : window.innerWidth <= 1439 && window.innerWidth >= 1366 ?  "+=820"
           : window.innerWidth  <= 1365 && window.innerWidth >= 1200 ?  "+=680"
          : "+=950",

          scrub: window.innerWidth >= 1024 && window.innerWidth <= 1199 ?    0.6 : 0.8,
          onScrubComplete: self => tl.pause,
          animation: tl
        });

        ScrollTrigger.create({
          trigger: ".cont-2",
          scroller: "[data-scroll-container]",
           start: window.innerWidth >= 1024 && window.innerWidth <= 1199 ?   "-450px"    
            : window.innerWidth  <= 1365 && window.innerWidth >= 1200 ?  "-450px" 
             :  window.innerHeight <= 900 && window.innerHeight >= 800 && window.innerWidth <= 1650 && window.innerWidth >= 1440 ?  "-400px" 

           :  "-450px",

          end:   window.innerWidth >= 1024 && window.innerWidth <= 1199 ?  "+=550"
          : window.innerWidth <= 1439 && window.innerWidth >= 1366 ?  "+=20"
          : window.innerWidth  <= 1365 && window.innerWidth >= 1200 ?  "+=2"
          :   "+=600",
        //    this.windowHeight <= 1099 &&
        // this.windowHeight >= 1000 &&
        // this.windowWidth >= 1920
            onEnter: function() {
            if(!__that.hasRotated){

            
            document
              .querySelector(".bottleitself")
              .classList.add("has-rotated");
            let totalFrames = 6;
              let imagePath = __that.locale == 'ge' ? "/img/shake" : "/img/shake_eng";
            let frameNumber = 0;
            setInterval(() => {
              if (frameNumber < totalFrames && frameNumber != totalFrames) {
                frameNumber++;

                document
                  .querySelector(".bottleitself")
                  .setAttribute("src", imagePath + `/${frameNumber}.png`);
              }
            }, 50);
            __that.hasRotated = true;
            // console.log(_that.hasRotated)
          
          }
          },

            //   onLeaveBack: function(){
            //   preventRotate();
            //   console.log('on enter back')


            // }
        });

           ScrollTrigger.create({
          trigger: ".cont-2",
          scroller: "[data-scroll-container]",
           start: window.innerWidth >= 1024 && window.innerWidth <= 1199 ?   "+=210 bottom"    
            : window.innerWidth  <= 1365 && window.innerWidth >= 1200 ?  "+=150 bottom" 
             :  window.innerHeight <= 900 && window.innerHeight >= 800 && window.innerWidth <= 1650 && window.innerWidth >= 1440 ?  "+=200 bottom" 

           :  "+=200 bottom",

          end:   window.innerWidth >= 1024 && window.innerWidth <= 1199 ?  "-=500"
          : window.innerWidth <= 1439 && window.innerWidth >= 1366 ?  "-=500"
          : window.innerWidth  <= 1365 && window.innerWidth >= 1200 ?  "-=500"
          :   "bottom bottom",
       
        // markers: true,
        onEnter: function(){
          // console.log('enter')
        },
            onLeaveBack: function() {
              preventRotate();
              // console.log('dsajhkdhjkasjhkdas');
          },

        });
      }





      if (this.windowHeight >= 1100 && this.windowWidth >= 1920) {
        let y1 = 1290;
        let x1 = -((this.windowWidth * 16.614583333333332) / 120) + 20;
      
        adjustToSize(y1, x1);
      } else if (
        this.windowHeight <= 900 &&
        this.windowHeight >= 800 &&
        this.windowWidth <= 1650 &&
        this.windowWidth >= 1440
      ) {
        let dist = pyramids.getBoundingClientRect().left + 250;
        let distToFromBottles = bottles.getBoundingClientRect().left - dist;
        // let y1 = 1100;
        let y1 = 900;
        let x1 = -distToFromBottles;
  
        adjustToSize2(y1, x1);
      }
      
      
      else if (
        this.windowHeight <= 1099 &&
        this.windowHeight >= 901 &&
        this.windowWidth <= 1650 &&
        this.windowWidth >= 1440
      ) {
        let dist = pyramids.getBoundingClientRect().left + 250;
        let distToFromBottles = bottles.getBoundingClientRect().left - dist;
        // let y1 = 1100;
        let y1 = 1020;
        let x1 = -distToFromBottles + 100;
  
        adjustToSize2(y1, x1);
      } else if (
        this.windowHeight <= 1300 &&
        this.windowHeight >= 1100 &&
        this.windowWidth <= 1650 &&
        this.windowWidth >= 1440
      ) {
        let dist = pyramids.getBoundingClientRect().left + 250;
        let distToFromBottles = bottles.getBoundingClientRect().left - dist;
        let y1 = 1100;
        let x1 = -distToFromBottles + 100;
      
        adjustToSize2(y1, x1);
      } else if (
        this.windowHeight <= 1500 &&
        this.windowHeight >= 1301 &&
        this.windowWidth <= 1650 &&
        this.windowWidth >= 1440
      ) {
        let dist = pyramids.getBoundingClientRect().left + 250;
        let distToFromBottles = bottles.getBoundingClientRect().left - dist;
        let y1 = 1100;
        let x1 = -distToFromBottles + 100;
    
        adjustToSize2(y1, x1);
      } else if (
        this.windowHeight <= 1700 &&
        this.windowHeight >= 1501 &&
        this.windowWidth <= 1650 &&
        this.windowWidth >= 1440
      ) {
        let dist = pyramids.getBoundingClientRect().left + 250;
        let distToFromBottles = bottles.getBoundingClientRect().left - dist;
        let y1 = 1100;
        let x1 = -distToFromBottles + 100;
    
        adjustToSize2(y1, x1);
      } else if (
        this.windowHeight <=899 &&
        this.windowHeight >= 800 &&
        this.windowWidth <= 1919 &&
        this.windowWidth >= 1651
      ) {
        let dist = pyramids.getBoundingClientRect().left + 250;
        let distToFromBottles = bottles.getBoundingClientRect().left - dist;
        let y1 = 1050;
        let x1 = -distToFromBottles + 100;
     
        adjustToSize2(y1, x1);
      }
      
      else if (
        this.windowHeight <= 1000 &&
        this.windowHeight >= 900 &&
        this.windowWidth <= 1919 &&
        this.windowWidth >= 1651
      ) {
        let dist = pyramids.getBoundingClientRect().left + 250;
        let distToFromBottles = bottles.getBoundingClientRect().left - dist;
        let y1 = 1050;
        let x1 = -distToFromBottles + 100;
     
        adjustToSize2(y1, x1);
      }
      
      else if (
        this.windowHeight <= 1099 &&
        this.windowHeight >= 1001 &&
        this.windowWidth <= 1919 &&
        this.windowWidth >= 1651
      ) {
        let dist = pyramids.getBoundingClientRect().left + 250;
        let distToFromBottles = bottles.getBoundingClientRect().left - dist;
        let y1 = 1100;
        let x1 = -distToFromBottles + 100;
     
        adjustToSize2(y1, x1);
      } else if (
        this.windowHeight <= 1200 &&
        this.windowHeight >= 1100 &&
        this.windowWidth <= 1919 &&
        this.windowWidth >= 1651
      ) {
        let dist = pyramids.getBoundingClientRect().left + 250;
        let distToFromBottles = bottles.getBoundingClientRect().left - dist;
        let y1 = 1100;
        let x1 = -distToFromBottles + 100;
      
        adjustToSize2(y1, x1);
      } else if (
        this.windowHeight <= 1400 &&
        this.windowHeight >= 1201 &&
        this.windowWidth <= 1919 &&
        this.windowWidth >= 1651
      ) {
        let dist = pyramids.getBoundingClientRect().left + 250;
        let distToFromBottles = bottles.getBoundingClientRect().left - dist;
        let y1 = 1150;
        let x1 = -distToFromBottles + 100;
      
        adjustToSize2(y1, x1);
      } else if (
        this.windowHeight <= 1700 &&
        this.windowHeight >= 1401 &&
        this.windowWidth <= 1919 &&
        this.windowWidth >= 1651
      ) {
        let dist = pyramids.getBoundingClientRect().left + 250;
        let distToFromBottles = bottles.getBoundingClientRect().left - dist;
        let y1 = 1200;
        let x1 = -distToFromBottles + 100;
     
        adjustToSize2(y1, x1);
      } else if (
        this.windowHeight <= 1099 &&
        this.windowHeight >= 1000 &&
        this.windowWidth >= 1920
      ) {
        let y1 = this.windowHeight ;
        let x1 = -340;
   
        adjustToSize2(y1, x1);
      } else if (
        this.windowHeight <= 999 &&
        this.windowHeight >= 900 &&
        this.windowWidth >= 1920
      ) {
        let y1 = 1080;
        let x1 = -280;
      
        adjustToSize2(y1, x1);
      } else if (
        this.windowHeight <= 899 &&
        this.windowHeight >= 800 &&
        this.windowWidth >= 1920
      ) {
        let y1 = 1030;
        let x1 = -360;
      
        adjustToSize2(y1, x1);
      }

      /// ====== heights ====
      else if (this.windowWidth <= 1919 && this.windowWidth >= 1730) {
        let dist = pyramids.getBoundingClientRect().left + 250;
        let distToFromBottles = bottles.getBoundingClientRect().left - dist;
        let y1 = 1060;
        let x1 = -distToFromBottles;

        adjustToSize2(y1, x1);
      } else if (this.windowWidth <= 1729 && this.windowWidth >= 1690) {
        let dist = pyramids.getBoundingClientRect().left + 250;
        let distToFromBottles = bottles.getBoundingClientRect().left - dist;
        let y1 = 1050;
        let x1 = -distToFromBottles;
    
        adjustToSize2(y1, x1);
      } else if (this.windowWidth <= 1689 && this.windowWidth >= 1627) {
        let dist = pyramids.getBoundingClientRect().left + 250;
        let distToFromBottles = bottles.getBoundingClientRect().left - dist;
        let y1 = this.windowHeight + 170;
        let x1 = -distToFromBottles;
        
        adjustToSize2(y1, x1);
      } else if (this.windowWidth <= 1626 && this.windowWidth >= 1440) {
        let dist = pyramids.getBoundingClientRect().left + 250;
        let distToFromBottles = bottles.getBoundingClientRect().left - dist;
        let y1 = 960;
        // let x1 = -distToFromBottles -100;
        let x1 = -400;
       
        adjustToSize2(y1, x1);
      } else if (this.windowWidth <= 1439 && this.windowWidth >= 1366) {
        let dist = pyramids.getBoundingClientRect().left + 250;
        let distToFromBottles = bottles.getBoundingClientRect().left - dist;
        let y1 = 890;
        // let x1 = -distToFromBottles - 150;
        let x1 = -370;
      
        adjustToSize2(y1, x1);
      } else if (this.windowWidth <= 1365 && this.windowWidth >= 1200) {
        let dist = pyramids.getBoundingClientRect().left  - 50;
        let distToFromBottles = bottles.getBoundingClientRect().left - dist;
        let y1 = 910;
        let x1 = -410;
       
        adjustToSize2(y1, x1);
      } else if (this.windowWidth <= 1199 && this.windowWidth >= 1024) {
        let dist = pyramids.getBoundingClientRect().left + 104;
        let distToFromBottles = bottles.getBoundingClientRect().left - dist;
        let y1 = 850;
        let x1 = -300;
      
        adjustToSize2(y1, x1);
      }

      ScrollTrigger.create({
        trigger: ".cont-2",
        scroller: "[data-scroll-container]",
        start: "+=500 bottom",
        end: "bottom +=100",
        scrub: true,
        toggleClass: { targets: "body", className: "yellow" }
      });

      if (this.windowWidth >= 1024) {
        ScrollTrigger.create({
          trigger: ".cont-3",
          scroller: "[data-scroll-container]",
          start: "-=200px bottom",
          end: "bottom +=90",
          scrub: true,
          toggleClass: {
            targets: [
              "body",
              ".landing-wrapper .cont-2 .ttl-wrapper",
              ".landing-wrapper .cont-2 .text-block .buy-btn",
              ".landing-wrapper .cont-3 .cocktail-slider",
              ".cont-4",
          
            ],
            className: "green"
          }
        });
      }
      if (this.windowWidth <= 1023) {
        ScrollTrigger.create({
          trigger: ".cont-3",
          scroller: "[data-scroll-container]",
          start: "+=200 bottom",
          end: "bottom +=100",
          scrub: true,
          toggleClass: {
            targets: [
              "body",
              ".landing-wrapper .cont-2 .ttl-wrapper",
              ".landing-wrapper .cont-2 .text-block .buy-btn"
            ],
            className: "green"
          }
        });
      }

      // ========================== CHANGE HEADER COLOR ==================== ///
      if (this.windowWidth <= 767) {
        // ScrollTrigger.create({
        //   trigger: ".cont-3",
        //   scroller: "[data-scroll-container]",
        //   start: "+=190 bottom",
        //   end: "bottom +=500",
        //   scrub: true,
        //   toggleClass: { targets: "header", className: "white" }
        // });
      // ScrollTrigger.create({
      //   trigger: ".cont-2",
      //   scroller: "[data-scroll-container]",
      //   start: "+=600 bottom",
      //   end: "+=920",
      //   scrub: true,
      //   toggleClass: { targets: "header", className: "black" }
      // });
      }
      if (this.windowWidth >= 768) {
        // ScrollTrigger.create({
        //   trigger: ".cont-3",
        //   scroller: "[data-scroll-container]",
        //   start: window.innerWidth >=768 &&  window.innerWidth <=1023 ? "+=262 bottom"
        //   : window.innerWidth >=1024 && window.innerWidth <=1365 ? "-=230 bottom"
        //   : window.innerWidth >=1366 ?"-=180 bottom"
        //   : "+=480 bottom",
        //   // end: "bottom +=500",
        //   end: "bottom +=200",
        //   scrub: true,
        //   toggleClass: { targets: "header", className: "white" }
        // });

      //     ScrollTrigger.create({
      //   trigger: ".cont-2",
      //   scroller: "[data-scroll-container]",
      //   start: "+=600 bottom",
      //   end: window.innerHeight >= 1200 ? "+=1500"
      //   : window.innerHeight >= 1200 ? "+=1200"
      //   : window.innerHeight >= 1200 ? "+=1300"
      //   :  "+=1300",
      //   scrub: true,
      //   toggleClass: { targets: "header", className: "black" }
      // });
      }

      // ScrollTrigger.create({
      //   trigger: ".cont-6",
      //   scroller: "[data-scroll-container]",
      //   start: "+=500 bottom",
      //   end: "+=4500",
      //   scrub: true,
      //   toggleClass: { targets: "header", className: "black" }
      // });

      // ========================== CHANGE HEADER COLOR ==================== ///

      // ScrollTrigger.create({
      //   trigger: ".cont-6",
      //   scroller: "[data-scroll-container]",
      //   start: "+=350 bottom",
      //   end: "+=9999",
      //   scrub: true,
      //   toggleClass: { targets: "body", className: "pink" }
      // });

      // each time the window updates, we should refresh ScrollTrigger and then update LocomotiveScroll.

      

      ScrollTrigger.addEventListener("refresh", () => {});

      // after everything is set up, refresh() ScrollTrigger and update LocomotiveScroll because padding may have been added for pinning, etc.
      ScrollTrigger.refresh();
    }
  },
  beforeDestroy() {
    this.Loco.destroy();
    this.Loco = null;
  },

  watch: {
    hasRotated(ns, os){
      // console.log(ns)
    },
    stopScrolling(newState, oldState) {
      if (newState == false) {
        this.Loco.start();
      } else if (newState == true) {
        this.Loco.stop();
      }
    },
    updateOnLoad: {
      immediate: true,
      handler(newState, oldState) {
        if (newState === "done") {
        }
      }
    },

    Loco: {
      handler(newState, oldState) {
        this.Loco.update();
      }
    },
    ageVerified(newState, oldState) {
      if (newState == true && this.Loco !== null) {
        this.Loco.stop();
        setTimeout(() => {
          this.Loco.start();
        }, 2000);
      }
    }
  },
  destroyed() {
    // this.$destroy();
      let Alltrigger = ScrollTrigger.getAll();
    for (let i = 0; i < Alltrigger.length; i++) {
      Alltrigger[i].kill(true);
    }
    if(this.Loco !== null) this.Loco.destroy();
  }
};
</script>

<style>
.custom-scroll {
  height: 100vh;
  overflow: auto;
}
</style>
